import { BaseRouteService } from 'core/services';

class ShipmentCostRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'shipment-cost/';
	}

	findTn(filter) {
		return super.create(this.base + 'search-tn', filter);
	}

	findCharge(filter) {
		return super.create(this.base + 'search-charge', filter);
	}

	uploadBillData(isOverride, sourceOfChange) {
		return super.create(this.base + 'upload-bill/?isOverride={isOverride}&sourceOfChange={sourceOfChange}', {
			isOverride,
			sourceOfChange,
		});
	}

	checkTrackingNumbers() {
		return super.create(this.base + 'check-tracking-numbers');
	}

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}
}

export default ShipmentCostRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ShipmentCostRouteService.js